import { useEffect, useState } from "react"
import Frame from "../Frames/Basic.js"
import API from "../../services/API.js"
import { Link, useParams } from "react-router-dom"
import Loader from "../Tools/Loader.js"
import { Alert, Button, Stack, Typography } from "@mui/material"
import { ArrowBack } from "@mui/icons-material"
import { txt } from "../../services/translation"

export default function Affiliate(){

    const {id} = useParams()

    const [sponsor, setSponsor] = useState(null)

    const [status, setStatus] = useState('loading')

    const statusIs = s => status === s

    const statusIsNot = s => status !== s

    useEffect(() => {

        API.post(`/affiliate/${id}`)
            .then(r => {
                console.log(r.data)
                setSponsor(r.data)
                setStatus('success')
            })
            .catch(e => setStatus('error' + e.response.status.toString()))

    }, [id])

    return (
        <Frame>
            <Stack spacing={2}>
                <Typography variant='h2'>{txt('accountAffiliationTitle')}</Typography>
    
                {statusIs('loading') && <Loader />}
    
                {statusIs('success') &&
                    <Alert severity="success">{txt('sponsorSuccess', { name: sponsor.name })}</Alert>
                }
    
                {statusIs('error409') &&
                    <Alert severity="warning">{txt('sponsorErrorOwnAccount')}</Alert>
                }
    
                {statusIs('error404') &&
                    <Alert severity="warning">{txt('sponsorErrorDeletedAccount')}</Alert>
                }
    
                {statusIs('error500') &&
                    <Alert severity="error">{txt('sponsorErrorGeneric')}</Alert>
                }
    
                {statusIsNot('loading') && 
                    <Link to="/">
                        <Button startIcon={<ArrowBack />}>{txt('returnToHome')}</Button>
                    </Link>
                }
            </Stack>
        </Frame>
    );
}